module.exports = __webpack_public_path__ + "static/104930662_662804864577821_7061648547956723741_o_optimized-613ec690e592bf9534cb8e6ff7c39d5f.jpg";